import React from "react"
import types from "prop-types"
import { useSolutionLevelReportExportContext } from "contexts/SolutionLevelReportExportContext"
import { Checkbox } from "components/shared/checkboxes"
import MassSelection from "shared/MassSelection"

const ReportableFieldSelectAnswerFiltersDetails = ({ reportableFieldId }) => {
  const {
    reportableFields,
    reportableFieldSelectAnswerFilters,
    setReportableFieldSelectAnswerFilterAnswers,
  } = useSolutionLevelReportExportContext()

  const reportableField = reportableFields.find((rf) => rf.id === reportableFieldId)
  const filter = reportableFieldSelectAnswerFilters.find((f) => f.reportableFieldId === reportableFieldId)

  if (!reportableField || !filter) return null

  const allAnswers = reportableField.options ?? []

  const toggleAnswer = (answer) => {
    const current = filter.selectedAnswers
    const updated = current.includes(answer)
      ? current.filter((a) => a !== answer)
      : [...current, answer]
    setReportableFieldSelectAnswerFilterAnswers(reportableFieldId, updated)
  }

  return (
    <div className="border border-lightgray-3 rounded p-4">
      <p className="required-prompt mb-4">{reportableField.name}</p>
      <MassSelection
        className="mb-4"
        selectAll={() => setReportableFieldSelectAnswerFilterAnswers(reportableFieldId, allAnswers)}
        deselectAll={() => setReportableFieldSelectAnswerFilterAnswers(reportableFieldId, [])}
      />
      {allAnswers.map((answer) => (
        <div key={answer} className="flex items-center">
          <Checkbox
            className="mr-2"
            onChange={() => toggleAnswer(answer)}
            uuid={`reportable-field-answer-checkbox-${reportableFieldId}-${answer}`}
            value={filter.selectedAnswers.includes(answer)}
          />
          <label className="hover:cursor-pointer" htmlFor={`reportable-field-answer-checkbox-${reportableFieldId}-${answer}`}>
            {answer}
          </label>
        </div>
      ))}
    </div>
  )
}

ReportableFieldSelectAnswerFiltersDetails.propTypes = {
  reportableFieldId: types.number.isRequired,
}

export default ReportableFieldSelectAnswerFiltersDetails
